/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IOfferHistoryRoomCountItem1 {
  /** Количество предложений для заданной комнатности **/
  offersCount: number;
  /** Количество комнат квартиры **/
  roomsCount: ERoomsCount;
}

export enum ERoomsCount {
  /** Отдельная комната(покупка/аренда отдельной комнаты в квартире) **/
  'OnlyRoom' = 'onlyRoom',
  /** Студия **/
  'Studio' = 'studio',
  /** Одна комната **/
  'One' = 'one',
  /** Две комнаты **/
  'Two' = 'two',
  /** Три комнаты **/
  'Three' = 'three',
  /** Четыре комнаты **/
  'Four' = 'four',
  /** Пять комнат **/
  'Five' = 'five',
  /** Шесть и более комнат **/
  'SixPlus' = 'sixPlus',
}
